import { champsMenuRechercheEnum } from '../../../modules/resultats-recherche/enums/champsMenuRecherche'
import { Collapse, Grid } from '@mui/material'
import { chargementIcone, ChargementTexteChamp, gestionChampsFormulaire } from '../utils/gestionChampsFormulaire'
import { ExpandLess, ExpandMore } from '@mui/icons-material'
import React, { Dispatch, FC, SetStateAction, useContext, useState } from 'react'
import { makeStyles } from 'tss-react/mui'
import styles from '../../../styles'
import { WHITE } from '../../../theme'
import { objectGetValues } from '../../../utils/ieCompatibility'
import { RechercheContext } from '../../../modules/resultats-recherche/utils/RechercheContext'
import { FormulaireRechercheModel } from '../../../modules/resultats-recherche/types/formulaireRechercheModel'

interface ChampSelectProps {
	typeChamps: champsMenuRechercheEnum
	index: number
	formulaireOuvert: string
	setFormulaireOuvert: Dispatch<SetStateAction<string>>
	formValues: FormulaireRechercheModel
}

const ChampSelect: FC<ChampSelectProps> = (
	{
		typeChamps,
		index,
		formulaireOuvert,
		setFormulaireOuvert,
		formValues
	}) => {
	const { classes, cx } = useStyles()
	const [survolChamp, setSurvolChamp] = useState('')
	const [voirPlusPrestation, setVoirPlusPrestation] = useState(false)
	const [voirPlusParking, setVoirPlusParking] = useState(false)
	const { filtres, setChampTouche } = useContext(RechercheContext)

	// Fonction permettant de gérer les bordures dynamiquement selon le type de champ survolé
	const gestionBordureChamp = (typeChamps: champsMenuRechercheEnum, index: number) => {
		// Si un champ est survolé
		if (survolChamp.length > 0) {
			// Récupération de l'index du type de champ parcouru
			const typeChampIndex = objectGetValues(champsMenuRechercheEnum).findIndex((champMenu) => champMenu === survolChamp)

			// On masque les bordures pour les éléments autour du champ survolé
			if (typeChampIndex === index || typeChampIndex === index + 1) {
				return false
			} else {
				if (typeChamps === champsMenuRechercheEnum.rechercheAvancee) {
					return false
				}
			}
			return true
		} else {
			// Affichage d'une bordure pour les champs qui ne sont pas "Recherche avancée"
			return typeChamps !== champsMenuRechercheEnum.rechercheAvancee
		}
	}

	return (
		<Grid
			container
			item
			xs={12}
			className={classes.champContainer}
			onMouseEnter={() => setSurvolChamp(typeChamps)}
			onMouseLeave={() => setSurvolChamp('')}
			style={{
				borderRight: gestionBordureChamp(typeChamps, index) ? '1px solid #8895a1' : 'none'
			}}
		>
			<Grid
				container
				item
				xs={12}
				justifyContent="space-between"
				alignItems="center"
				className={classes.champTexteContainer}
				onClick={() => {
					setChampTouche(true)
					setFormulaireOuvert((prevState) => prevState.length === 0 || prevState !== typeChamps ? typeChamps : '')
				}}
			>
				<Grid container item xs minWidth={0} className={classes.champTexte}>
					{chargementIcone(typeChamps)}
					<Grid container item xs>
						{ChargementTexteChamp(formValues, typeChamps)}
					</Grid>
				</Grid>

				{
					formulaireOuvert === typeChamps ? (
						<ExpandLess />
					) : (
						<ExpandMore />
					)
				}
			</Grid>
			{
				formulaireOuvert === typeChamps && (
					<Collapse
						in={formulaireOuvert === typeChamps}
						timeout="auto"
						unmountOnExit
						addEndListener={() => {
						}}
						className={
							cx(
								classes.collapseStyle,
								{
									[classes.formulaireTypeBien]: typeChamps === champsMenuRechercheEnum.typeBien,
									[classes.formulaireRechercheAvancee]: typeChamps === champsMenuRechercheEnum.rechercheAvancee
								}
							)
						}
					>
						{gestionChampsFormulaire(typeChamps, voirPlusPrestation, setVoirPlusPrestation, filtres, voirPlusParking, setVoirPlusParking)}
					</Collapse>
				)
			}
		</Grid>
	)
}

const useStyles = makeStyles()((theme) => ({
	champContainer: {
		position: 'relative'
	},
	collapseStyle: {
		zIndex: 1,
		minWidth: 180,
		maxWidth: 360,
		height: 'fit-content !important',
		maxHeight: 340,
		position: 'absolute',
		left: 0,
		top: 50,
		bottom: 'unset',
		width: '100%',
		background: WHITE,
		borderRadius: 15,
		marginTop: 30,
		boxShadow: '0 25px 50px 0 rgba(18, 41, 65, 0.1)',
		padding: '31px 32px 22px',
		boxSizing: 'content-box',
		overflow: 'auto',
		'&::-webkit-scrollbar': {
			width: 16
		},
		'&::-webkit-scrollbar-thumb': {
			background: 'transparent',
			borderRadius: 30,
			boxShadow: 'inset 0 0 10px 10px #D0D5DA',
			border: 'solid 4px transparent'
		}
	},
	formulaireTypeBien: {
		width: '140%',
		maxWidth: 430
	},
	formulaireRechercheAvancee: {
		width: 545,
		maxWidth: 545,
		left: 'unset',
		right: '-40%'
	},
	champTexte: {
		alignItems: 'center',
		'& div': {
			textOverflow: 'ellipsis',
			overflow: 'hidden'
		},
		'& span': {
			...styles(theme).text2,
			whiteSpace: 'nowrap',
			marginLeft: 18
		}
	},
	champTexteContainer: {
		padding: '20px 30px 20px 27px',
		cursor: 'pointer',
		'&:hover': {
			background: theme.palette.blue['5'],
			borderRadius: 38,
			boxShadow: '0px 0px 10px #00000040'
		}
	}
}))

export default ChampSelect